<div *ngIf="!isClientSelected" class="opacity-100 fixed inset-0 z-40 bg-black"></div>
<div *ngIf="!isClientSelected"
     class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none flex w-full">
  <div class="p-5 flex w-full">
    <div>
      <h2
        class="font-medium leading-tight text-white text-2xl mt-0 mb-2">{{'lang.home.switchClient'|translate}}</h2>
    </div>
    <!-- <div class="text-white"><b>{{connectCodeService?.connectcode}}</b></div>
    <div class="text-white"> {{connectCodeService?.server}}</div> -->
  </div>
  <div
    class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
    <div class="flex flex-wrap">
      <button
        class="items-center p-4 justify-center mx-1 text-white opacity-75 hover:opacity-100 focus:opacity-100 border-transparent rounded hover:border-white focus:border-8 focus:border-white outline-none"
        *ngFor="let client of clients" (click)="selectClient(client)" type="button"
        #clientDiv id="{{client?.id}}">
        <img class="mx-auto flex w-24 h-24 bg-cover" alt="Mandantenlogo"
             src="{{client?.primaryCompany?.logo?.url? client?.primaryCompany?.logo?.url : './../assets/img/no-image.png'}}">
        <span class="flex justify-center mt-4">
          {{client?.name}}
        </span>
      </button>
      <button *ngIf="clients.length!== 0 && clientPagination.value.pages > 1"
              class="items-center p-4 justify-center mx-1 text-white opacity-75 hover:opacity-100 focus:opacity-100 border-transparent rounded hover:border-white focus:border-8 focus:border-white outline-none rounded"
              (click)="loadClient()" type="button">
        <span class="justify-center items-center flex w-24 h-24 bg-cover text-white text-6xl">
          ...
        </span>
        <span class="flex justify-center mt-4">
          &nbsp;
        </span>
      </button>
      <button *ngIf="!clientsLoading && clients.length === 0"
              class="items-center p-4 justify-center mx-1 text-white opacity-75 hover:opacity-100 focus:opacity-100 border-transparent rounded hover:border-white focus:border-8 focus:border-white outline-none rounded"
              (click)="signOut()" type="button">
        <span class="justify-center items-center flex bg-cover text-white text-2xl">
          {{'lang.globals.noClientsWarning'|translate}}
        </span>
      </button>
    </div>
  </div>
</div>
